import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import React from 'react';
import PropTypes from 'prop-types';
import { MdClose } from 'react-icons/md';
import styled from 'styled-components';
import { defineMessages, useIntl, FormattedMessage } from '@techstyle/react-intl';
import Button from '../Button';
import { mobile } from '../styles';
var messages = defineMessages({
  deselectLabel: {
    id: 'site_product_filter.deselect_button',
    defaultMessage: 'Dismiss {filterValue} filter'
  }
});
var TagHeader = styled.div.withConfig({
  displayName: "FilterTags__TagHeader",
  componentId: "sc-rb5tm7-0"
})(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  font-size: 14px;\n  line-height: 32px;\n  color: #333;\n\n  ", "\n"], mobile(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: 16px;\n    line-height: 48px;\n  "]))));
var HeaderLabelWrapper = styled.span.withConfig({
  displayName: "FilterTags__HeaderLabelWrapper",
  componentId: "sc-rb5tm7-1"
})(["\n  ", ";\n"], _ref => {
  var headerStyle = _ref.headerStyle;
  return headerStyle;
});
var ClearAllButton = styled(Button).attrs(() => ({
  variant: 'clearAllFilters'
})).withConfig({
  displayName: "FilterTags__ClearAllButton",
  componentId: "sc-rb5tm7-2"
})(["\n  appearance: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  color: #333;\n\n  &,\n  &:focus,\n  &:hover {\n    text-decoration: underline;\n  }\n\n  ", ";\n"], _ref2 => {
  var buttonStyle = _ref2.buttonStyle;
  return buttonStyle;
});
var TagList = styled.ul.withConfig({
  displayName: "FilterTags__TagList",
  componentId: "sc-rb5tm7-3"
})(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  list-style-type: none;\n  margin: -4px 0 0 0;\n\n  ", ";\n"], _ref3 => {
  var tagListStyle = _ref3.tagListStyle;
  return tagListStyle;
});
var Tag = styled.li.withConfig({
  displayName: "FilterTags__Tag",
  componentId: "sc-rb5tm7-4"
})(["\n  padding: 0 0 0 8px;\n  margin: 4px 4px 0 0;\n  background: #eeeeee;\n  border-radius: 4px;\n  text-align: left;\n  font-size: 12px;\n  line-height: 24px;\n  color: #333;\n\n  ", "\n\n  ", ";\n"], mobile(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 14px;\n    line-height: 32px;\n  "]))), _ref4 => {
  var tagStyle = _ref4.tagStyle;
  return tagStyle;
});
var DeselectIcon = styled(MdClose).withConfig({
  displayName: "FilterTags__DeselectIcon",
  componentId: "sc-rb5tm7-5"
})(["\n  display: inline-block;\n  vertical-align: -2px;\n  color: #999;\n"]);
var DeselectButton = styled(Button).attrs(() => ({
  variant: 'deselectFilter',
  children: /*#__PURE__*/React.createElement(DeselectIcon, null)
})).withConfig({
  displayName: "FilterTags__DeselectButton",
  componentId: "sc-rb5tm7-6"
})(["\n  width: auto;\n  height: 24px;\n  appearance: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0 6px 0 3px;\n  margin-left: 2px;\n  font-size: 12px;\n\n  ", ";\n\n  ", ";\n"], mobile(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    height: 32px;\n    font-size: 16px;\n  "]))), _ref5 => {
  var buttonStyle = _ref5.buttonStyle;
  return buttonStyle;
});

var FilterTags = _ref6 => {
  var clearAllButtonComponent = _ref6.clearAllButtonComponent,
      clearAllButtonStyle = _ref6.clearAllButtonStyle,
      deselectButtonStyle = _ref6.deselectButtonStyle,
      headerStyle = _ref6.headerStyle,
      onClearAll = _ref6.onClearAll,
      selectedFilters = _ref6.selectedFilters,
      tagListStyle = _ref6.tagListStyle,
      tagStyle = _ref6.tagStyle,
      rest = _objectWithoutProperties(_ref6, ["clearAllButtonComponent", "clearAllButtonStyle", "deselectButtonStyle", "headerStyle", "onClearAll", "selectedFilters", "tagListStyle", "tagStyle"]);

  var intl = useIntl();
  var ClearAllBtn = clearAllButtonComponent || ClearAllButton;
  return /*#__PURE__*/React.createElement("div", rest, /*#__PURE__*/React.createElement(TagHeader, null, /*#__PURE__*/React.createElement(HeaderLabelWrapper, {
    headerStyle: headerStyle
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "site_product_filter.filtered_by",
    defaultMessage: "Filtered by:"
  })), /*#__PURE__*/React.createElement(ClearAllBtn, {
    onClick: onClearAll,
    "data-autotag": "filter-clear-all",
    buttonStyle: clearAllButtonStyle
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "site_product_filter.clear_all",
    defaultMessage: "Clear all"
  }))), /*#__PURE__*/React.createElement(TagList, {
    "data-autotag": "filtered-by-textbox",
    tagListStyle: tagListStyle
  }, selectedFilters.map(value => {
    var deselectLabel = intl.formatMessage(messages.deselectLabel, {
      filterValue: value.labelString
    });
    return /*#__PURE__*/React.createElement(Tag, {
      key: "".concat(value.filterField.field, "-").concat(value.filterValue),
      "data-autotag": "filtered-by-option",
      tagStyle: tagStyle
    }, value.label, /*#__PURE__*/React.createElement(DeselectButton, {
      "aria-label": deselectLabel,
      "data-autotag": "filtered-by-option-close-icon",
      buttonStyle: deselectButtonStyle,
      onClick: event => value.onDismiss(event, value)
    }));
  })));
};
/**
 * See: ../ProductListingFilter/__fixtures__/filterData.json
 * This consists of information for both the category's label
 * and key, and the filter's value and label. The labels are
 * necessary to display the filter and to generate slugified
 * internationalization keys.
 */


var filterValue = PropTypes.shape({
  filterField: PropTypes.shape({
    field: PropTypes.string,
    label: PropTypes.string
  }),
  filterValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  labelString: PropTypes.string.isRequired,
  label: PropTypes.node,
  onDismiss: PropTypes.func
});
FilterTags.propTypes = {
  clearAllButtonComponent: PropTypes.elementType,
  clearAllButtonStyle: PropTypes.any,
  deselectButtonStyle: PropTypes.any,
  headerStyle: PropTypes.any,
  onClearAll: PropTypes.func,
  selectedFilters: PropTypes.arrayOf(filterValue).isRequired,
  tagListStyle: PropTypes.any,
  tagStyle: PropTypes.any
};
export default FilterTags;